import localeUtils from 'utils/LanguageLocale';

/**
 * Gating helper for the Customer Service SMS "Text Us" tile (ECSC-9743, ECSC-9919, ECSC-9756).
 *
 * The locale's `customerServiceSMS` feature flag is the sole authoritative gate:
 *   - Flag OFF -> tile is never shown.
 *   - Flag ON  -> tile is shown for all users.
 *
 * Visibility is ALWAYS resolved client-side only so the tile never lands in the
 * server-rendered (SSR/SEO) HTML.
 */

/**
 * Reads the locale-specific `customerServiceSMS` feature flag.
 * @returns {boolean} true when the flag for the current locale is enabled.
 */
const isSmsTileFlagEnabled = () => {
    const config = Sephora.configurationSettings?.customerServiceSMS;

    if (localeUtils.isFRCanada()) {
        return !!config?.caFrench?.isEnabled;
    }

    if (localeUtils.isCanada()) {
        return !!config?.caEnglish?.isEnabled;
    }

    return !!config?.usEnglish?.isEnabled;
};

/**
 * Resolves whether the SMS "Text Us" tile should render. MUST be called
 * client-side only (e.g. inside useEffect); returns false during SSR so the
 * tile is never part of the server-rendered HTML.
 *
 * The locale feature flag is the sole gate.
 * @returns {boolean}
 */
const shouldRenderSmsTile = () => {
    if (Sephora.isNodeRender) {
        return false;
    }

    return isSmsTileFlagEnabled();
};

export {
    isSmsTileFlagEnabled,
    shouldRenderSmsTile
};

export default shouldRenderSmsTile;
